<template>
  <section class="section container pt-0">
    <div class="title is-3 has-text-centered">{{ $t("landing pages") }}</div>
    <div class="buttons">
      <button class="button is-primary is-rounded" @click="create_page">
        <span class="icon">
          <i class="fa fa-plus"></i>
        </span>
        <span>{{ $t("create landing page") }}</span>
      </button>
      <button class="button is-info is-rounded" @click="retrieve_pages">
        <span class="icon">
          <i class="fa fa-refresh"></i>
        </span>
        <span>{{ $t("refresh") }}</span>
      </button>
    </div>

    <div class="columns is-multiline mt-4">
      <div class="column is-one-quarter" v-for="page in pages" :key="page.name">
        <a :href="`/landing/page/edit/${page.path}`" class="card">
          <div class="card-image">
            <figure class="image is-4by3">
              <img :src="random_thumb()" />
            </figure>
          </div>
          <div class="card-content">
            <a class="title is-5" @click="edit_page(page)">{{ page.name }}</a>
            <!-- <p class="subtitle">{{ page.path }}</p> -->
          </div>
          <footer class="card-footer">
            <a href="#" class="card-footer-item" @click="view_page(page)">{{
              $t("view")
            }}</a>
            <a href="#" class="card-footer-item" @click="edit_page(page)">{{
              $t("edit")
            }}</a>
            <a href="#" class="card-footer-item" @click="delete_page(page)">{{
              $t("delete")
            }}</a>
          </footer>
        </a>
      </div>
    </div>
    <page-modal ref="page_modal" @success="retrieve_pages" />
  </section>
</template>

<script>
import {
  error_message,
  get,
  del,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import PageModal from "./page_modal/Index.vue";

export default {
  name: "LandingPages",
  components: {
    PageModal,
  },
  data() {
    return {
      pages: [],
      thumbs: [
        "https://static.vecteezy.com/system/resources/previews/001/857/005/non_2x/404-error-landing-page-template-free-vector.jpg",
        "https://www.searchenginejournal.com/wp-content/uploads/2023/08/best-landing-page-examples-64e6080f990bb-sej-1280x720.png",
        "https://cdn.prod.website-files.com/65bb7884c67879aa0d84f24e/65c0eb721ea864f342f436f8_What-are-landing-pages-and-why-do-you-need-to-use-them.jpeg",
        "https://uicreative.s3.ap-southeast-1.amazonaws.com/wp-content/uploads/2019/11/23140033/landing-pages-interior-design.jpg",
        "https://community.es/wp-content/uploads/landing-pages-que-convierten.jpg",
      ],
    };
  },
  methods: {
    random_thumb() {
      return this.thumbs[Math.floor(Math.random() * this.thumbs.length)];
    },
    retrieve_pages() {
      let v = this;
      v.$root.loader(true);
      get("/landing/page/all", {})
        .then((response) => {
          v.pages = response;
        })
        .catch((error) => {
          console.log(error);
          error_message(error);
        })
        .finally(() => v.$root.loader(false));
    },
    create_page() {
      let v = this;
      v.$refs.page_modal.show();
    },
    edit_page(page) {
      let v = this;
      v.$router.push({
        path: `/landing/page/edit/${page.path}`,
      });
    },
    view_page(page) {
      let v = this;
      window.open(`/pages/${page.path}`, "_blank");
    },
    delete_page(page) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure you want to delete this page?"),
        v,
        () => {
          del(`/landing/page/${page.path}`)
            .then(() => {
              v.retrieve_pages();
              success_message(v.$t("page deleted successfully"));
            })
            .catch((error) => {
              console.log(error);
              error_message(error);
            });
        }
      );
    },
  },
  mounted() {
    this.retrieve_pages();
  },
  created() {},
};
</script>

<style scoped></style>
